import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Spinner, Text } from '@chakra-ui/react'

interface iModalPayloadProps {
  isOpen: boolean
  onClose: () => void
  isLoading: boolean
  payload: string
}

export const ModalPayload: React.FC<iModalPayloadProps> = ({ isOpen, onClose, isLoading, payload }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'2xl'}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Payload</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={'1.5rem'}>
          {isLoading
            ? <Spinner size={'md'} color={'var(--Azul)'} />
            : (
              <Text as={'pre'} fontSize={'.75rem'} whiteSpace={'pre-wrap'} wordBreak={'break-word'} maxHeight={'60vh'} overflowY={'auto'}>
                {payload}
              </Text>
              )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
